export default __webpack_public_path__ + "static/media/avatar_grumpy_cat1.327fc4e3.mp3";